import { useDrawer, useMediaQuery } from '@/global/hooks'
import { FunctionComponent, useCallback, useMemo } from 'react'
import { ADDRESS_SEARCH_MODAL_ID } from '@/modules/accredited-establishments/components/Filters'
import { useFilters, useList } from '@/modules/accredited-establishments/hooks'
import { getDescription, getTitle } from './NotFoundMessage.helpers'
import {
  Action,
  ErrorTemplate,
  createAction
} from '@/modules/accredited-establishments/components/List'

const NotFoundMessage: FunctionComponent = () => {
  const isMobile = useMediaQuery({ maxWidth: 'mobile' })

  const { open: openAddressSearchModal } = useDrawer(ADDRESS_SEARCH_MODAL_ID)

  const { notFoundEstablishments } = useList()

  const {
    hasFilters,
    providerName,
    clearFilters,
    updateProviderName,
    setProviderSearchOpen
  } = useFilters()

  /* Sem termo o campo perde a razao de estar aberto, entao ele volta a lupa. */
  const handleClearSearch = useCallback(() => {
    updateProviderName('')
    setProviderSearchOpen(false)
    // `useFilters` recria as funcoes a cada render do provider
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleFindByOtherCity = useCallback(
    () => openAddressSearchModal(),
    [openAddressSearchModal]
  )

  const actions = useMemo((): Action[] => {
    if (providerName) {
      /*
       * O handoff de mobile nao tem botao: o termo fica no campo de busca fixo
       * no topo, e e por lá que a pessoa limpa a busca.
       */
      if (isMobile) return []

      return [
        createAction({
          label: 'Limpar busca',
          /* O handoff pede o botao magenta, que no design system e a variante `cta`. */
          variant: 'cta',
          onClick: handleClearSearch
        })
      ]
    }

    return hasFilters
      ? [
          createAction({
            label: 'Limpar filtros',
            onClick: clearFilters,
            isMobile
          }),
          createAction({
            label: 'Buscar por outra cidade',
            variant: 'secondary',
            onClick: handleFindByOtherCity,
            isMobile
          })
        ]
      : [
          createAction({
            label: 'Buscar por outra cidade',
            onClick: handleFindByOtherCity,
            isMobile
          })
        ]
  }, [
    providerName,
    hasFilters,
    clearFilters,
    handleClearSearch,
    handleFindByOtherCity,
    isMobile
  ])

  const title = useMemo(
    () => getTitle({ hasFilters, providerName }),
    [providerName, hasFilters]
  )

  const description = useMemo(
    () => getDescription({ hasFilters, providerName }),
    [providerName, hasFilters]
  )

  return (
    <ErrorTemplate
      active={notFoundEstablishments}
      title={title}
      description={description}
      actions={actions}
    />
  )
}

export { NotFoundMessage }
